
// import { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// // Point these at wherever you upload the PHP files on your server
// const REPORTS_API_URL = "https://www.assocham.org/api/knowledge-reports.php";
// const VOICE_API_URL = "https://www.assocham.org/api/assocham-voice.php";
// const GLOBAL_API_URL = "https://www.assocham.org/api/global-research.php";

// export default function KnowledgeCenter() {
//   const [activeTab, setActiveTab] = useState("reports");

//   return (
//     <div
//       style={{
//         background: "#FFFFFF",
//         paddingBottom: "20px",
//       }}
//     >
//       <div className="container">

//         {/* ================= HEADER ================= */}
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             marginBottom: 28,
//             flexWrap: "wrap",
//             gap: 16,
//           }}
//         >
//           {/* Tabs */}
//           <div
//             style={{
//               background: "#FFFFFF",
//               padding: 5,
//               borderRadius: 100,
//               display: "flex",
//               gap: 6,
//               border: "1px solid #e5e7eb",
//               boxShadow: "0 4px 14px rgba(0,0,0,0.05)",
//             }}
//           >
//             <button
//               onClick={() => setActiveTab("reports")}
//               style={{
//                 padding: "10px 22px",
//                 borderRadius: 100,
//                 border: "none",
//                 cursor: "pointer",
//                 fontWeight: 700,
//                 fontSize: 13,
//                 transition: "0.3s",
//                 background: activeTab === "reports" ? "#F59C00" : "transparent",
//                 color: activeTab === "reports" ? "#fff" : "#444",
//               }}
//             >
//               Reports
//             </button>

//             <button
//               onClick={() => setActiveTab("newsletter")}
//               style={{
//                 padding: "10px 22px",
//                 borderRadius: 100,
//                 border: "none",
//                 cursor: "pointer",
//                 fontWeight: 700,
//                 fontSize: 13,
//                 transition: "0.3s",
//                 background: activeTab === "newsletter" ? "#8B0F1A" : "transparent",
//                 color: activeTab === "newsletter" ? "#fff" : "#444",
//               }}
//             >
//               ASSOCHAM Voice
//             </button>

//             <button
//               onClick={() => setActiveTab("global")}
//               style={{
//                 padding: "10px 22px",
//                 borderRadius: 100,
//                 border: "none",
//                 cursor: "pointer",
//                 fontWeight: 700,
//                 fontSize: 13,
//                 transition: "0.3s",
//                 background: activeTab === "global" ? "#F59C00" : "transparent",
//                 color: activeTab === "global" ? "#fff" : "#444",
//               }}
//             >
//               Bulletins
//             </button>
//           </div>
//         </div>

//         {/* ================= SWITCH CONTENT ================= */}
//         {activeTab === "reports" ? (
//           <ReportsCarousel />
//         ) : activeTab === "newsletter" ? (
//           <NewsletterGrid />
//         ) : (
//           <GlobalResearchGrid />
//         )}
//       </div>
//     </div>
//   );
// }

// /* ====================== SHARED: fetch hook ====================== */

// function useFetchList(url) {
//   const [items, setItems] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     let cancelled = false;

//     fetch(url)
//       .then((res) => {
//         if (!res.ok) throw new Error("Network response was not ok");
//         return res.json();
//       })
//       .then((json) => {
//         if (cancelled) return;
//         if (json.success) {
//           setItems(json.data);
//         } else {
//           setError(json.message || "Failed to load data");
//         }
//       })
//       .catch(() => {
//         if (!cancelled) setError("Failed to load data");
//       })
//       .finally(() => {
//         if (!cancelled) setLoading(false);
//       });

//     return () => {
//       cancelled = true;
//     };
//   }, [url]);

//   return { items, loading, error };
// }

// /* ====================== REPORTS CAROUSEL (backend-driven) ====================== */

// function ReportsCarousel() {
//   const { items: reports, loading, error } = useFetchList(REPORTS_API_URL);

//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [isTransitioning, setIsTransitioning] = useState(false);

//   const cardsToShow = 3;
//   const totalCards = reports.length;
//   const extendedReports = [...reports, ...reports];

//   const goToNext = () => {
//     if (isTransitioning || totalCards === 0) return;
//     setIsTransitioning(true);
//     setCurrentIndex((prev) => prev + 1);
//   };

//   useEffect(() => {
//     if (totalCards === 0) return;
//     const interval = setInterval(goToNext, 4000);
//     return () => clearInterval(interval);
//   }, [totalCards]);

//   useEffect(() => {
//     if (totalCards === 0) return;
//     if (currentIndex >= totalCards) {
//       setTimeout(() => {
//         setIsTransitioning(false);
//         setCurrentIndex(0);
//       }, 500);
//     } else {
//       setTimeout(() => {
//         setIsTransitioning(false);
//       }, 500);
//     }
//   }, [currentIndex, totalCards]);

//   return (
//     <div>
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           marginBottom: 18,
//         }}
//       >
//         <div style={{ fontSize: 18, fontWeight: 700, color: "#222" }}>
//           Knowledge Reports
//         </div>
//         {/* <Link to="/knowledge-report">
//         <span
//           onClick={goToNext}
//           style={{ cursor: "pointer", color: "#f7941d", fontWeight: 600, fontSize: 13 }}
//         >
//           View All →
//         </span>
//         </Link> */}
//         <Link
//   to="/knowledge-report"
//   onClick={goToNext}
// >
//   <span
//     style={{
//       cursor: "pointer",
//       color: "#f7941d",
//       fontWeight: 600,
//       fontSize: 13,
//     }}
//   >
//     View All →
//   </span>
// </Link>
//       </div>

//       {loading && (
//         <div style={{ padding: "30px 0", color: "#888", fontSize: 14 }}>
//           Loading reports...
//         </div>
//       )}

//       {!loading && error && (
//         <div style={{ padding: "30px 0", color: "#c0392b", fontSize: 14 }}>
//           {error}
//         </div>
//       )}

//       {!loading && !error && totalCards === 0 && (
//         <div style={{ padding: "30px 0", color: "#888", fontSize: 14 }}>
//           No reports available right now.
//         </div>
//       )}

//       {!loading && !error && totalCards > 0 && (
//         <div style={{ overflow: "hidden" }}>
//           <div
//             style={{
//               display: "flex",
//               transition: isTransitioning ? "transform 0.5s ease-in-out" : "none",
//               transform: `translateX(-${currentIndex * (100 / cardsToShow)}%)`,
//             }}
//           >
//             {extendedReports.map((report, i) => (
//               <div
//                 key={i}
//                 style={{
//                   minWidth: `${100 / cardsToShow}%`,
//                   paddingRight: 18,
//                   boxSizing: "border-box",
//                 }}
//               >
//                 <ReportCard report={report} />
//               </div>
//             ))}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// /* ====================== REPORT CARD ====================== */

// function ReportCard({ report }) {
//   return (
//     <div
//       className="card-hover"
//       style={{
//         background: "#FFFFFF",
//         borderRadius: 24,
//         overflow: "hidden",
//         position: "relative",
//         border: "1px solid #ececec",
//         boxShadow: "0 10px 25px rgba(0,0,0,0.06)",
//         transition: "0.35s ease",
//         height: "100%",
//         display: "flex",
//         flexDirection: "column",
//       }}
//     >
//       <div
//         style={{
//           position: "absolute",
//           top: 0,
//           left: 0,
//           width: "100%",
//           height: 90,
//           background: "linear-gradient(135deg, rgb(98, 94, 94) 0%, rgb(96, 96, 96) 50%, rgb(152, 146, 146) 100%)",
//           clipPath: "polygon(0 0, 100% 0, 100% 72%, 85% 100%, 60% 80%, 35% 100%, 0 72%)",
//           zIndex: 0,
//         }}
//       />

//       <div
//         style={{
//           position: "absolute",
//           top: 18,
//           right: 18,
//           width: 48,
//           height: 48,
//           borderRadius: "50%",
//           background: "rgba(255,255,255,0.15)",
//           backdropFilter: "blur(6px)",
//           zIndex: 1,
//         }}
//       />

//       <div style={{ position: "relative", padding: "26px 20px 0", zIndex: 2 }}>
//         <div style={{ borderRadius: 18, overflow: "hidden", boxShadow: "0 8px 20px rgba(0,0,0,0.12)" }}>
//           <img
//             src={report.img}
//             alt=""
//             style={{ width: "100%", height: 360, objectFit: "cover", display: "block" }}
//           />
//         </div>
//       </div>

//       <div
//         style={{
//           padding: "18px 20px 22px",
//           position: "relative",
//           zIndex: 2,
//           flex: 1,
//           display: "flex",
//           flexDirection: "column",
//         }}
//       >
//         <div
//           style={{
//             fontSize: 15,
//             fontWeight: 700,
//             color: "#222",
//             lineHeight: 1.4,
//             marginBottom: 8,
//             display: "-webkit-box",
//             WebkitLineClamp: 2,
//             WebkitBoxOrient: "vertical",
//             overflow: "hidden",
//             textOverflow: "ellipsis",
//           }}
//         >
//           {report.title}
//         </div>

//         <div style={{ fontSize: 12, color: "#888", marginBottom: 18 }}>
//           {report.date}
//         </div>

//         <a
//           href={report.link}
//           target="_blank"
//           rel="noopener noreferrer"
//           className="bg-white hover:bg-[#f7941d] transition-colors duration-300 hover:text-white text-[#8b0f1a]"
//           style={{
//             display: "inline-flex",
//             alignItems: "center",
//             gap: 8,
//             border: "2px solid #f7941d",
//             padding: "11px 18px",
//             borderRadius: 100,
//             fontSize: 12,
//             fontWeight: 700,
//             cursor: "pointer",
//             transition: "0.3s",
//             boxShadow: "0 6px 14px rgba(247,148,29,0.25)",
//             marginTop: "auto",
//             textDecoration: "none",
//             width: "fit-content",
//           }}
//         >
//           ⬇ Download PDF
//         </a>
//       </div>
//     </div>
//   );
// }

// /* ====================== NEWSLETTER GRID (ASSOCHAM Voice, backend-driven) ====================== */

// function NewsletterGrid() {
//   const { items: newsletters, loading, error } = useFetchList(VOICE_API_URL);

//   return (
//     <div>
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           marginBottom: 18,
//         }}
//       >
//         <div style={{ fontSize: 18, fontWeight: 700, color: "#222" }}>
//           Newsletters
//         </div>
//         <span style={{ cursor: "pointer", color: "#da2128", fontWeight: 600, fontSize: 13 }}>
//           View All →
//         </span>
//       </div>

//       {loading && (
//         <div style={{ padding: "30px 0", color: "#888", fontSize: 14 }}>
//           Loading...
//         </div>
//       )}

//       {!loading && error && (
//         <div style={{ padding: "30px 0", color: "#c0392b", fontSize: 14 }}>
//           {error}
//         </div>
//       )}

//       {!loading && !error && newsletters.length === 0 && (
//         <div style={{ padding: "30px 0", color: "#888", fontSize: 14 }}>
//           No data available right now.
//         </div>
//       )}

//       {!loading && !error && newsletters.length > 0 && (
//         <div
//           style={{
//             display: "grid",
//             gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
//             gap: 24,
//           }}
//         >
//           {newsletters.map((newsletter, i) => (
//             <NewsletterCard key={i} newsletter={newsletter} />
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }

// /* ====================== GLOBAL RESEARCH CENTRE GRID (backend-driven, latest 3) ====================== */

// function GlobalResearchGrid() {
//   const { items: globalItems, loading, error } = useFetchList(GLOBAL_API_URL);

//   return (
//     <div>
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           marginBottom: 18,
//         }}
//       >
//         <div style={{ fontSize: 18, fontWeight: 700, color: "#222" }}>
//           Global Research
//         </div>
//         <span style={{ cursor: "pointer", color: "#da2128", fontWeight: 600, fontSize: 13 }}>
//           View All →
//         </span>
//       </div>

//       {loading && (
//         <div style={{ padding: "30px 0", color: "#888", fontSize: 14 }}>
//           Loading...
//         </div>
//       )}

//       {!loading && error && (
//         <div style={{ padding: "30px 0", color: "#c0392b", fontSize: 14 }}>
//           {error}
//         </div>
//       )}

//       {!loading && !error && globalItems.length === 0 && (
//         <div style={{ padding: "30px 0", color: "#888", fontSize: 14 }}>
//           No data available right now.
//         </div>
//       )}

//       {!loading && !error && globalItems.length > 0 && (
//         <div
//           style={{
//             display: "grid",
//             gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
//             gap: 24,
//           }}
//         >
//           {globalItems.map((item, i) => (
//             <NewsletterCard key={i} newsletter={item} />
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }

// /* ====================== NEWSLETTER CARD (shared by ASSOCHAM Voice + Global Research Centre) ====================== */

// function NewsletterCard({ newsletter }) {
//   return (
//     <div
//       className="card-hover"
//       style={{
//         background: "#FFFFFF",
//         borderRadius: 24,
//         overflow: "hidden",
//         position: "relative",
//         border: "1px solid #ececec",
//         boxShadow: "0 10px 25px rgba(0,0,0,0.06)",
//         transition: "0.35s ease",
//         height: "100%",
//         display: "flex",
//         flexDirection: "column",
//       }}
//     >
//       <div
//         style={{
//           position: "absolute",
//           top: 0,
//           left: 0,
//           width: "100%",
//           height: 90,
//           background: "linear-gradient(135deg, rgb(98, 94, 94) 0%, rgb(96, 96, 96) 50%, rgb(152, 146, 146) 100%)",
//           clipPath: "polygon(0 0, 100% 0, 100% 72%, 85% 100%, 60% 80%, 35% 100%, 0 72%)",
//           zIndex: 0,
//         }}
//       />

//       <div
//         style={{
//           position: "absolute",
//           top: 18,
//           right: 18,
//           width: 48,
//           height: 48,
//           borderRadius: "50%",
//           background: "rgba(255,255,255,0.15)",
//           backdropFilter: "blur(6px)",
//           zIndex: 1,
//         }}
//       />

//       <div style={{ position: "relative", padding: "26px 20px 0", zIndex: 2 }}>
//         <div style={{ borderRadius: 18, overflow: "hidden", boxShadow: "0 8px 20px rgba(0,0,0,0.12)" }}>
//           <img
//             src={newsletter.img}
//             alt=""
//             style={{ width: "100%", height: 360, objectFit: "cover", display: "block" }}
//           />
//         </div>
//       </div>

//       <div
//         style={{
//           padding: "18px 20px 22px",
//           position: "relative",
//           zIndex: 2,
//           flex: 1,
//           display: "flex",
//           flexDirection: "column",
//         }}
//       >
//         <div
//           style={{
//             fontSize: 15,
//             fontWeight: 700,
//             color: "#222",
//             lineHeight: 1.4,
//             marginBottom: 8,
//             display: "-webkit-box",
//             WebkitLineClamp: 2,
//             WebkitBoxOrient: "vertical",
//             overflow: "hidden",
//             textOverflow: "ellipsis",
//           }}
//         >
//           {newsletter.title}
//         </div>

//         <div style={{ fontSize: 12, color: "#888", marginBottom: 18 }}>
//           {newsletter.issue}
//         </div>

//         <a
//           href={newsletter.link}
//           target="_blank"
//           rel="noopener noreferrer"
//           className="bg-white hover:bg-[#f7941d] transition-colors duration-300 hover:text-white text-[#8b0f1a]"
//           style={{
//             display: "inline-flex",
//             alignItems: "center",
//             gap: 8,
//             border: "2px solid #f7941d",
//             padding: "11px 18px",
//             borderRadius: 100,
//             fontSize: 12,
//             fontWeight: 700,
//             cursor: "pointer",
//             transition: "0.3s",
//             boxShadow: "0 6px 14px rgba(139,15,26,0.25)",
//             marginTop: "auto",
//             textDecoration: "none",
//             width: "fit-content",
//           }}
//         >
//           Read Full Issue →
//         </a>
//       </div>
//     </div>
//   );
// }






// new new code 







import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

// API endpoints
const REPORTS_API_URL = "https://www.assocham.org/api/knowledge-reports.php";
const VOICE_API_URL = "https://www.assocham.org/api/assocham-voice.php";
const GLOBAL_API_URL = "https://www.assocham.org/api/global-research.php";

export default function KnowledgeCenter() {
  const [activeTab, setActiveTab] = useState("reports");

  return (
    <div
      style={{
        background: "#FFFFFF",
        paddingBottom: "20px",
      }}
    >
      <div className="container">

        {/* ================= HEADER ================= */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 28,
            flexWrap: "wrap",
            gap: 16,
          }}
        >
          {/* Tabs */}
          <div
            style={{
              background: "#FFFFFF",
              padding: 5,
              borderRadius: 100,
              display: "flex",
              gap: 6,
              border: "1px solid #e5e7eb",
              boxShadow: "0 4px 14px rgba(0,0,0,0.05)",
            }}
          >
            <button
              onClick={() => setActiveTab("reports")}
              style={{
                padding: "10px 22px",
                borderRadius: 100,
                border: "none",
                cursor: "pointer",
                fontWeight: 700,
                fontSize: 13,
                transition: "0.3s",
                background: activeTab === "reports" ? "#F59C00" : "transparent",
                color: activeTab === "reports" ? "#fff" : "#444",
              }}
            >
              Reports
            </button>

            <button
              onClick={() => setActiveTab("newsletter")}
              style={{
                padding: "10px 22px",
                borderRadius: 100,
                border: "none",
                cursor: "pointer",
                fontWeight: 700,
                fontSize: 13,
                transition: "0.3s",
                background: activeTab === "newsletter" ? "#8B0F1A" : "transparent",
                color: activeTab === "newsletter" ? "#fff" : "#444",
              }}
            >
              ASSOCHAM Voice
            </button>

            <button
              onClick={() => setActiveTab("global")}
              style={{
                padding: "10px 22px",
                borderRadius: 100,
                border: "none",
                cursor: "pointer",
                fontWeight: 700,
                fontSize: 13,
                transition: "0.3s",
                background: activeTab === "global" ? "#F59C00" : "transparent",
                color: activeTab === "global" ? "#fff" : "#444",
              }}
            >
              Bulletins
            </button>
          </div>
        </div>

        {/* ================= SWITCH CONTENT ================= */}
        {activeTab === "reports" ? (
          <ReportsCarousel />
        ) : activeTab === "newsletter" ? (
          <NewsletterGrid />
        ) : (
          <GlobalResearchGrid />
        )}
      </div>
    </div>
  );
}

/* ====================== SHARED: fetch hook ====================== */

function useFetchList(url) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    fetch(url)
      .then((res) => {
        if (!res.ok) throw new Error("Network response was not ok");
        return res.json();
      })
      .then((json) => {
        if (cancelled) return;
        if (json.success) {
          setItems(json.data);
        } else {
          setError(json.message || "Failed to load data");
        }
      })
      .catch(() => {
        if (!cancelled) setError("Failed to load data");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [url]);

  return { items, loading, error };
}

/* ====================== REPORTS CAROUSEL (backend-driven) ====================== */

function ReportsCarousel() {
  const { items: reports, loading, error } = useFetchList(REPORTS_API_URL);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const cardsToShow = 3;
  const totalCards = reports.length;
  const extendedReports = [...reports, ...reports];

  const goToNext = () => {
    if (isTransitioning || totalCards === 0) return;
    setIsTransitioning(true);
    setCurrentIndex((prev) => prev + 1);
  };

  useEffect(() => {
    if (totalCards === 0) return;
    const interval = setInterval(goToNext, 4000);
    return () => clearInterval(interval);
  }, [totalCards]);

  useEffect(() => {
    if (totalCards === 0) return;
    if (currentIndex >= totalCards) {
      setTimeout(() => {
        setIsTransitioning(false);
        setCurrentIndex(0);
      }, 500);
    } else {
      setTimeout(() => {
        setIsTransitioning(false);
      }, 500);
    }
  }, [currentIndex, totalCards]);

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 18,
        }}
      >
        <div style={{ fontSize: 18, fontWeight: 700, color: "#222" }}>
          Knowledge Reports
        </div>
        {/* View All – now points to React route */}
        <Link to="/knowledge/reports">
          <span
            style={{
              cursor: "pointer",
              color: "#f7941d",
              fontWeight: 600,
              fontSize: 13,
            }}
          >
            View All →
          </span>
        </Link>
      </div>

      {loading && (
        <div style={{ padding: "30px 0", color: "#888", fontSize: 14 }}>
          Loading reports...
        </div>
      )}

      {!loading && error && (
        <div style={{ padding: "30px 0", color: "#c0392b", fontSize: 14 }}>
          {error}
        </div>
      )}

      {!loading && !error && totalCards === 0 && (
        <div style={{ padding: "30px 0", color: "#888", fontSize: 14 }}>
          No reports available right now.
        </div>
      )}

      {!loading && !error && totalCards > 0 && (
        <div style={{ overflow: "hidden" }}>
          <div
            style={{
              display: "flex",
              transition: isTransitioning ? "transform 0.5s ease-in-out" : "none",
              transform: `translateX(-${currentIndex * (100 / cardsToShow)}%)`,
            }}
          >
            {extendedReports.map((report, i) => (
              <div
                key={i}
                style={{
                  minWidth: `${100 / cardsToShow}%`,
                  paddingRight: 18,
                  boxSizing: "border-box",
                }}
              >
                <ReportCard report={report} />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

/* ====================== REPORT CARD ====================== */

function ReportCard({ report }) {
  return (
    <div
      className="card-hover"
      style={{
        background: "#FFFFFF",
        borderRadius: 24,
        overflow: "hidden",
        position: "relative",
        border: "1px solid #ececec",
        boxShadow: "0 10px 25px rgba(0,0,0,0.06)",
        transition: "0.35s ease",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: 90,
          background: "linear-gradient(135deg, rgb(98, 94, 94) 0%, rgb(96, 96, 96) 50%, rgb(152, 146, 146) 100%)",
          clipPath: "polygon(0 0, 100% 0, 100% 72%, 85% 100%, 60% 80%, 35% 100%, 0 72%)",
          zIndex: 0,
        }}
      />

      <div
        style={{
          position: "absolute",
          top: 18,
          right: 18,
          width: 48,
          height: 48,
          borderRadius: "50%",
          background: "rgba(255,255,255,0.15)",
          backdropFilter: "blur(6px)",
          zIndex: 1,
        }}
      />

      <div style={{ position: "relative", padding: "26px 20px 0", zIndex: 2 }}>
        <div style={{ borderRadius: 18, overflow: "hidden", boxShadow: "0 8px 20px rgba(0,0,0,0.12)" }}>
          {/* Image links to React detail page */}
          <Link to={`/knowledge/reports/${report.slug}`}>
            <img
              src={report.img}
              alt={report.title}
              style={{
                width: "100%",
                height: 360,
                objectFit: "cover",
                display: "block",
                cursor: "pointer",
              }}
            />
          </Link>
        </div>
      </div>

      <div
        style={{
          padding: "18px 20px 22px",
          position: "relative",
          zIndex: 2,
          flex: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            fontSize: 15,
            fontWeight: 700,
            color: "#222",
            lineHeight: 1.4,
            marginBottom: 8,
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {report.title}
        </div>

        <div style={{ fontSize: 12, color: "#888", marginBottom: 18 }}>
          {report.date}
        </div>

        {/* FIXED: purane PHP publication-details.php ki jagah ab naye React
           detail page (/knowledge/reports/:slug) par le jaata hai — wahi
           page real download_url (knowledge-reports-detail.php se) dikhata hai.
           Styling bilkul same rakhi hai, sirf destination internal route hai. */}
        <Link
          to={`/knowledge/reports/${report.slug}`}
          className="bg-white hover:bg-[#f7941d] transition-colors duration-300 hover:text-white text-[#8b0f1a]"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            border: "2px solid #f7941d",
            padding: "11px 18px",
            borderRadius: 100,
            fontSize: 12,
            fontWeight: 700,
            cursor: "pointer",
            transition: "0.3s",
            boxShadow: "0 6px 14px rgba(247,148,29,0.25)",
            marginTop: "auto",
            textDecoration: "none",
            width: "fit-content",
          }}
        >
          ⬇ Download PDF
        </Link>
      </div>
    </div>
  );
}

/* ====================== NEWSLETTER GRID (ASSOCHAM Voice, backend-driven) ====================== */

function NewsletterGrid() {
  const { items: newsletters, loading, error } = useFetchList(VOICE_API_URL);

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 18,
        }}
      >
        <div style={{ fontSize: 18, fontWeight: 700, color: "#222" }}>
          Newsletters
        </div>
        <span style={{ cursor: "pointer", color: "#da2128", fontWeight: 600, fontSize: 13 }}>
          View All →
        </span>
      </div>

      {loading && (
        <div style={{ padding: "30px 0", color: "#888", fontSize: 14 }}>
          Loading...
        </div>
      )}

      {!loading && error && (
        <div style={{ padding: "30px 0", color: "#c0392b", fontSize: 14 }}>
          {error}
        </div>
      )}

      {!loading && !error && newsletters.length === 0 && (
        <div style={{ padding: "30px 0", color: "#888", fontSize: 14 }}>
          No data available right now.
        </div>
      )}

      {!loading && !error && newsletters.length > 0 && (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: 24,
          }}
        >
          {newsletters.map((newsletter, i) => (
            <NewsletterCard key={i} newsletter={newsletter} />
          ))}
        </div>
      )}
    </div>
  );
}

/* ====================== GLOBAL RESEARCH CENTRE GRID (backend-driven, latest 3) ====================== */

function GlobalResearchGrid() {
  const { items: globalItems, loading, error } = useFetchList(GLOBAL_API_URL);

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 18,
        }}
      >
        <div style={{ fontSize: 18, fontWeight: 700, color: "#222" }}>
          Global Research
        </div>
        <span style={{ cursor: "pointer", color: "#da2128", fontWeight: 600, fontSize: 13 }}>
          View All →
        </span>
      </div>

      {loading && (
        <div style={{ padding: "30px 0", color: "#888", fontSize: 14 }}>
          Loading...
        </div>
      )}

      {!loading && error && (
        <div style={{ padding: "30px 0", color: "#c0392b", fontSize: 14 }}>
          {error}
        </div>
      )}

      {!loading && !error && globalItems.length === 0 && (
        <div style={{ padding: "30px 0", color: "#888", fontSize: 14 }}>
          No data available right now.
        </div>
      )}

      {!loading && !error && globalItems.length > 0 && (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: 24,
          }}
        >
          {globalItems.map((item, i) => (
            <NewsletterCard key={i} newsletter={item} />
          ))}
        </div>
      )}
    </div>
  );
}

/* ====================== NEWSLETTER CARD (shared by ASSOCHAM Voice + Global Research Centre) ====================== */

function NewsletterCard({ newsletter }) {
  return (
    <div
      className="card-hover"
      style={{
        background: "#FFFFFF",
        borderRadius: 24,
        overflow: "hidden",
        position: "relative",
        border: "1px solid #ececec",
        boxShadow: "0 10px 25px rgba(0,0,0,0.06)",
        transition: "0.35s ease",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: 90,
          background: "linear-gradient(135deg, rgb(98, 94, 94) 0%, rgb(96, 96, 96) 50%, rgb(152, 146, 146) 100%)",
          clipPath: "polygon(0 0, 100% 0, 100% 72%, 85% 100%, 60% 80%, 35% 100%, 0 72%)",
          zIndex: 0,
        }}
      />

      <div
        style={{
          position: "absolute",
          top: 18,
          right: 18,
          width: 48,
          height: 48,
          borderRadius: "50%",
          background: "rgba(255,255,255,0.15)",
          backdropFilter: "blur(6px)",
          zIndex: 1,
        }}
      />

      <div style={{ position: "relative", padding: "26px 20px 0", zIndex: 2 }}>
        <div style={{ borderRadius: 18, overflow: "hidden", boxShadow: "0 8px 20px rgba(0,0,0,0.12)" }}>
          <img
            src={newsletter.img}
            alt=""
            style={{ width: "100%", height: 360, objectFit: "cover", display: "block" }}
          />
        </div>
      </div>

      <div
        style={{
          padding: "18px 20px 22px",
          position: "relative",
          zIndex: 2,
          flex: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            fontSize: 15,
            fontWeight: 700,
            color: "#222",
            lineHeight: 1.4,
            marginBottom: 8,
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {newsletter.title}
        </div>

        <div style={{ fontSize: 12, color: "#888", marginBottom: 18 }}>
          {newsletter.issue}
        </div>
          <a
        
          href={newsletter.link}
          target="_blank"
          rel="noopener noreferrer"
          className="bg-white hover:bg-[#f7941d] transition-colors duration-300 hover:text-white text-[#8b0f1a]"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            border: "2px solid #f7941d",
            padding: "11px 18px",
            borderRadius: 100,
            fontSize: 12,
            fontWeight: 700,
            cursor: "pointer",
            transition: "0.3s",
            boxShadow: "0 6px 14px rgba(139,15,26,0.25)",
            marginTop: "auto",
            textDecoration: "none",
            width: "fit-content",
          }}
        >
          Read Full Issue →
        </a>
      </div>
    </div>
  );
}